import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { issuesAPI } from '../../services/api';
import { LoadingPage } from '../../components/Loading';
import './Public.css';

const stripHtml = (html) => (html ? html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : '');

const Issues = () => {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchIssues();
  }, []);

  const fetchIssues = async () => {
    try {
      setLoading(true);
      const response = await issuesAPI.getAll();
      const data = Array.isArray(response.data) ? response.data : response.data?.results || [];
      setIssues(
        data
          .filter((issue) => issue.is_active)
          .sort((a, b) => (a.display_order || 999) - (b.display_order || 999))
      );
    } catch (error) {
      console.error('Failed to fetch issues:', error);
      setIssues([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingPage message="載入核心服務中..." />;

  return (
    <div className="public-page issues-page">
      <div className="page-header">
        <div className="container">
          <h1>核心服務</h1>
          <p className="page-subtitle">我們聚焦四大核心服務體系，全方位守護兒童及青少年的身心健康</p>
        </div>
      </div>

      <div className="container">
        {issues.length > 0 ? (
          <div className="issues-grid">
            {issues.map((issue) => (
              <div key={issue.id} className="issue-card card">
                {issue.is_featured && (
                  <span className="badge badge-featured">重點服務</span>
                )}
                {issue.featured_image && (
                  <img
                    src={issue.featured_image}
                    alt={issue.title}
                    className="issue-image"
                  />
                )}
                <div className="issue-content">
                  <h3>{issue.title}</h3>
                  <p className="issue-description">
                    {stripHtml(issue.description).slice(0, 150)}
                    {stripHtml(issue.description).length > 150 && '...'}
                  </p>
                  <Link
                    to={`/services/${issue.slug || issue.id}`}
                    className="btn btn-primary"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <p>暫無服務項目</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Issues;
